import IBlock2Others from "./IBlock2Others";
import { EnumUtil } from "@/app";

export default class Block2Others implements IBlock2Others {
    constructor(
        public cohabitation: string = EnumUtil.EMPTY_OPTION,
        public childrenCount: string = "",
        public housingTenure: string = EnumUtil.EMPTY_OPTION,
        public housingZipCode: string = "",
        public birthplace: string = "",
        public education: string = EnumUtil.EMPTY_OPTION,
        public nationality: string = "",
        public primaryDocumentType: string = EnumUtil.EMPTY_OPTION,
        public primaryDocumentNumber: string = "",
        public primaryDocumentValidity: Date | undefined = undefined,
    ) {
    }
}
